<i18n>
{
  "zh": {
    "searchPlaceholder": "游戏名称/APPID",
    "gameAdd": "添加游戏",
    "gameManage": "游戏管理",
    "empty": "您还没有游戏，请先添加游戏"
  },
  "en": {
    "searchPlaceholder": "Game Name / APPID",
    "gameAdd": "Game Add",
    "gameManage": "Game Manage",
    "empty": "No game, Please add game first"
  }
}
</i18n>
<template>
  <transition name="fade">
    <div
      v-loading="isLoading"
      class="game-select"
    >
      <div class="game-select-search">
        <el-input
          v-model="search"
          :placeholder="$t('searchPlaceholder')"
          prefix-icon="el-icon-search"
          @keyup.enter.native="getGameList"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getGameList"
          />
        </el-input>
      </div>
      <Scrollbar
        v-if="appList.length > 0"
        style="height: 350px; "
        wrap-style="overflow-x: hidden;"
      >
        <div
          v-for="appItem in appList"
          :key="appItem.app_id"
          class="game-select-item"
          :class="{
            'is-active': appItem.app_id === currentApp.app_id
          }"
          :title="appItem.name"
          @click="onAppItemClick(appItem)"
        >
          <el-image
            class="game-icon"
            :src="appItem.game_icon"
          >
            <div
              slot="error"
              class="image-slot"
            >
              <img
                src="@/assets/default_game.png"
                alt=""
              >
            </div>
          </el-image>
          {{ appItem.game_name }}
        </div>
      </Scrollbar>

      <div
        v-else
        class="empty-text"
      >
        {{ $t('empty') }}
      </div>
      <div class="game-select-operation">
        <el-link
          type="primary"
          size="medium"
          @click="onAppAdd"
        >
          {{ $t('gameAdd') }}
        </el-link>
        <el-link
          type="primary"
          size="medium"
          @click="onAppManage"
        >
          {{ $t('gameManage') }}
        </el-link>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  Scrollbar,
} from 'element-ui';
import { getGameList } from '@/service/game';
import {
  mapState,
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  components: {
    Scrollbar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appList: [],
      search: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapState(['currentRole', 'company']),
    ...mapGetters(['currentApp']),
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.getGameList();
      }
    },
  },
  methods: {
    ...mapMutations(['changeApp']),
    getGameList() {
      this.isLoading = true;
      return getGameList({
        cid: this.currentRole === 'USER' ? '0' : this.company.cid,
        search: this.search,
      }).then((res) => {
        this.appList = res.gameList;
        return this.appList;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onAppManage() {
      if (this.$route.path !== '/appList') {
        this.$router.push('/appList');
      }
    },
    onAppAdd() {
      if (this.$route.path !== '/appAdd') {
        this.$router.push('/appAdd');
      }
    },
    onAppItemClick(appItem) {
      this.changeApp(appItem);
      this.$router.push(`/appDetail/${appItem.app_id}`);
    },
  },
};
</script>

<style lang="scss">
.empty-text {
  line-height: 1.5;
  padding: $padding-lg;
  text-align: center;
}
</style>
